export default __webpack_public_path__ + "c0a74f28c9db42c7d005a8666ee73046.svg";